// @tennis-matches/core/version
// Single source of truth for the UI version shown in the footer.
// Migrated from src/version.js
// Bump this value whenever you ship a new build.
export const APP_VERSION = "0.9.222";

// Date of the version/build shown in the footer (YYYY-MM-DD).
// Keep this in sync when bumping APP_VERSION.
export const APP_VERSION_DATE = "2026-11-05";
